import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MijnTokensBrowserAnalyticsService } from '../analytics/analytics.service';
import { MijnTokensBrowserNavigation } from '../mijn-tokens-browser.navigation';
import { MijnTokensBrowserService } from '../mijn-tokens-browser.service';

/**
 * @module RegisterNameWrapperModule
 * @ngdoc component
 * @name NameWrapperComponent
 */
@Component({
    selector: 'tokens-browser-name-wrapper',
    templateUrl: 'name.wrapper.component.html',
    standalone: false
})
export class NameWrapperComponent implements OnInit {
    public registeredNames: string[];

    public name: string;

    public constructor(
        private readonly activatedRoute: ActivatedRoute,
        private readonly analyticsService: MijnTokensBrowserAnalyticsService,
        private readonly navigation: MijnTokensBrowserNavigation,
        private readonly mijnTokensBrowserService: MijnTokensBrowserService
    ) {}

    public ngOnInit(): void {
        this.navigation.init(this.activatedRoute.parent);
        this.mijnTokensBrowserService.getRegisteredNames().subscribe((result) => (this.registeredNames = result));
        this.name = this.mijnTokensBrowserService.getName();
        this.sendFormStepAnalytics();
    }

    public onNewName(name: string): void {
        this.mijnTokensBrowserService.setName(name);
        this.navigation.toDevice();
    }

    public onBack(name: string): void {
        this.mijnTokensBrowserService.setName(name);
        this.navigation.toPincode();
    }

    private sendFormStepAnalytics(): void {
        this.analyticsService.pushFormStepAnalytics(MijnTokensBrowserNavigation.NAME, 3, 'start');
    }
}
